import { render } from "./SidenavCollapseItem.vue?vue&type=template&id=908264b4"
import script from "./SidenavCollapseItem.vue?vue&type=script&lang=js"
export * from "./SidenavCollapseItem.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Nok/source/tccc/tccc-station-23-v2/tccc-frontend-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__